import { useStore } from '@/store';
import { useRouter } from 'vue-router';

export default defineNuxtPlugin(() => {
  const router = useRouter();
  const store = useStore();
  if (process.client) {
    let currentPosition = window.history.state?.position;
    window.addEventListener('popstate', () => {
      if (currentPosition < window.history.state?.position) {
        store.SET_NAVIGATION_TYPE('forward');
      } else {
        store.SET_NAVIGATION_TYPE('back');
      }
      currentPosition = window.history.state?.position;
    });
    router.beforeEach((to, from, next) => {
      setTimeout(() => {
        if (!['forward', 'back'].includes(store.navigationInfo.navigationType)) {
          store.SET_NAVIGATION_TYPE('push');
        }
        next();
      });
    });
    router.afterEach(() => {
      store.PUSH_NAVIGATION_HISTORY();
      setTimeout(() => {
        store.SET_NAVIGATION_TYPE('push');
      }, 1000);
    });
  }
});
